import { MapPin, Route, Clock, History, TrendingUp, Shield } from 'lucide-react'
import { FadeIn } from '../../ui/FadeIn'
import { GlassCard } from '../../ui/GlassCard'
import { useLanguage } from '../../../contexts/LanguageContext'

export function RealTimeTrackingModule() {
  const { t } = useLanguage()

  // Datos de ejemplo para Location Register
  const recentRegisters = [
    { time: '14:30', locationKey: 'product.tracking.zones.a', status: 'completed' },
    { time: '14:25', locationKey: 'product.tracking.zones.b', status: 'completed' },
    { time: '14:20', locationKey: 'product.tracking.zones.c', status: 'completed' },
    { time: '14:15', locationKey: 'product.tracking.zones.a', status: 'completed' },
    { time: '14:10', locationKey: 'product.tracking.zones.d', status: 'completed' },
  ]

  return (
    <FadeIn className="h-full">
      <GlassCard className="h-full">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="text-sm font-semibold tracking-tight">{t('product.tracking.title')}</div>
            <div className="mt-1 text-xs text-white/65">
              {t('product.tracking.desc')}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="grid size-10 place-items-center rounded-xl bg-white/10 border border-white/10">
              <MapPin className="size-5 text-nexus-cyan" />
            </span>
            <span className="grid size-10 place-items-center rounded-xl bg-white/10 border border-white/10">
              <Route className="size-5 text-nexus-blue" />
            </span>
          </div>
        </div>

        <div className="mt-5 grid gap-3">
          {/* Location Now */}
          <div className="rounded-2xl border border-white/10 bg-white/6 p-4">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <MapPin className="size-4 text-nexus-cyan" />
                <div className="text-xs text-white/60">{t('product.tracking.location.now')}</div>
              </div>
              <div className="text-xs text-white/60">{t('product.tracking.location.now.precision')}</div>
            </div>
            <div className="mt-2 h-2 rounded-full bg-white/8 overflow-hidden">
              <div className="h-full w-3/4 bg-gradient-to-r from-nexus-blue to-nexus-cyan" />
            </div>
            <div className="mt-2 text-xs text-white/70">
              {t('product.tracking.location.now.desc')}
            </div>
          </div>

          {/* Location Register */}
          <div className="rounded-2xl border border-white/10 bg-white/6 p-4">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2">
                <History className="size-4 text-nexus-blue" />
                <div className="text-xs text-white/60">{t('product.tracking.register')}</div>
              </div>
              <div className="flex items-center gap-1 text-xs text-white/60">
                <Clock className="size-3" />
                {t('product.tracking.register.interval')}
              </div>
            </div>
            
            {/* Estadísticas rápidas */}
            <div className="grid grid-cols-3 gap-2 mb-3">
              <div className="rounded-xl border border-white/10 bg-white/5 p-2 text-center">
                <div className="text-xs font-semibold text-white">24</div>
                <div className="text-[10px] text-white/60">{t('product.tracking.register.today')}</div>
              </div>
              <div className="rounded-xl border border-white/10 bg-white/5 p-2 text-center">
                <div className="text-xs font-semibold text-white">5.2km</div>
                <div className="text-[10px] text-white/60">{t('product.tracking.register.distance')}</div>
              </div>
              <div className="rounded-xl border border-white/10 bg-white/5 p-2 text-center">
                <div className="text-xs font-semibold text-green-400">100%</div>
                <div className="text-[10px] text-white/60">{t('product.tracking.register.coverage')}</div>
              </div>
            </div>

            {/* Historial reciente */}
            <div className="space-y-1.5">
              <div className="text-xs text-white/60 mb-1.5 flex items-center gap-1">
                <TrendingUp className="size-3" />
                {t('product.tracking.register.recent')}
              </div>
              {recentRegisters.map((register, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between rounded-lg border border-white/10 bg-white/5 px-2.5 py-1.5"
                >
                  <div className="flex items-center gap-2 min-w-0 flex-1">
                    <div className="w-1.5 h-1.5 rounded-full bg-nexus-blue flex-shrink-0" />
                    <div className="min-w-0 flex-1">
                      <div className="text-xs text-white/90 truncate">{t(register.locationKey)}</div>
                      <div className="text-[10px] text-white/60 flex items-center gap-1">
                        <Clock className="size-2.5" />
                        {register.time}
                      </div>
                    </div>
                  </div>
                  <Shield className="size-3 text-green-400 flex-shrink-0" />
                </div>
              ))}
            </div>

            {/* Información adicional */}
            <div className="mt-3 rounded-lg border border-white/10 bg-white/5 p-2.5">
              <div className="text-[10px] text-white/70 leading-relaxed">
                <strong className="text-white/90">{t('product.tracking.register.traceability')}</strong> {t('product.tracking.register.traceability.desc')}
              </div>
            </div>
          </div>
        </div>
      </GlassCard>
    </FadeIn>
  )
}


